import Swal from "sweetalert2";

$(document).on({
    click: function (e) {
        e.preventDefault();

        let form = $(this).closest('form');
        let formArray = form.serializeArray();
        let formData = {};
        let hasEmptyFields = false;

        form.find('[required]').css('border', '');
        form.find('.custom-checkbox a').css('color', '');

        form.find('[required]').each(function () {
            let fieldType = $(this).attr('type');
            let fieldName = $(this).attr('name');
            let fieldValue = $(this).val() ? $(this).val().trim() : '';

            if ((fieldType === 'text' || fieldType === 'email' || fieldType === 'password' || fieldType === 'date' || fieldType === 'checkbox' || fieldType === undefined) && fieldValue === '') {
                hasEmptyFields = true;
                $(this).css('border', '1px solid red');
            }
            if (fieldType === 'checkbox' && !$(`input[name="${fieldName}"]:checked`).length) {
                hasEmptyFields = true;
                $(this).closest('.custom-checkbox, .checkbox-container').find('a').css('color', 'red');
            }
        });

        if (hasEmptyFields) {
            Swal.fire({
                position: "top-end",
                icon: 'error',
                text: required_fields,
                timer: 2000,
                showConfirmButton: false
            });
            return;
        }

        $.each(formArray, function (_, field) {
            formData[field.name] = field.value.trim();
        });

        form.find('input[type="checkbox"]').each(function () {
            formData[$(this).attr('name')] = $(this).is(':checked') ? '1' : '0';
        });

        $.post(url_treasure_hunter, {
            action: 'participateTreasure',
            datas: JSON.stringify(formData)
        }, null, 'json')
            .then(function (resp) {
                if (!resp.error) {
                    $('.treasure-image-container').hide();
                }

                $('#modalTreasure').fadeOut();

                Swal.fire({
                    position: "top-end",
                    icon: !resp.error ? 'success' : 'error',
                    text: resp.message,
                    timer: 3000,
                    showConfirmButton: false
                });
                form[0].reset();
            })
            .fail(function() {
                Swal.fire({
                    position: "top-end",
                    icon: 'error',
                    text: 'An error occurred while processing your request',
                    timer: 2000,
                    showConfirmButton: false
                });
            });
    }
}, '#participateTreasureHunter');

$(document).on({
    click: function (e) {
        $("#modalTreasure").fadeIn();

        if ($("#modalTreasure").length === 0) {
            $.post(url_treasure_hunter, {
                action: 'addParticipateTreasure',
                datas: {
                    id_treasure: $(this).data('id_treasure'),
                    page_id: $(this).data('page_id'),
                },
            }, null, 'json')
                .then(function (resp) {
                    if (!resp.error) {
                        $('.treasure-image-container').hide();
                    }
                    if (!resp.modal) {
                        Swal.fire({
                            position: "top-end",
                            title: resp.title,
                            icon: !resp.error ? 'success' : 'error',
                            text: resp.message,
                            timer: 3000,
                            showConfirmButton: false
                        });
                    } else {
                        if (!resp.reward) {
                            Swal.fire({
                                title: resp.title,
                                icon: !resp.error ? 'success' : 'error',
                                text: resp.message
                            });
                        } else {
                            Swal.fire({
                                title: resp.title,
                                icon: !resp.error ? 'success' : 'error',
                                html: resp.reward
                            });
                        }
                    }
                })
                .fail(function() {
                    Swal.fire({
                        position: "top-end",
                        icon: 'error',
                        text: 'An error occurred while processing your request',
                        timer: 2000,
                        showConfirmButton: false
                    });
                });
        }
    }
}, '#participateTreasureHunterAdd');

$(document).on("click", "#closeModal", function() {
    $("#modalTreasure").fadeOut();
});

$(document).on("click", "#modalTreasure", function(e) {
    if ($(e.target).is("#modalTreasure")) {
        $(this).fadeOut();
    }
});

$(document).keydown(function(e) {
    if (e.key === "Escape" && $("#modalTreasure").is(":visible")) {
        $("#modalTreasure").fadeOut();
    }
});